import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import teamTokens from "screens/Settings/Team/Team.tokens";

const { size } = teamTokens;

/**
 * Paper-plane glyph traced from the Teams design's "Send Invite" action — a
 * 14px stroked outline, lighter and smaller than the shared raster icon the
 * screen used before.
 */
export const SendInviteIcon: React.FC<SvgIconProps> = ({ sx, ...rest }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={size.inviteIconStrokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{
      width: size.inviteIcon,
      height: size.inviteIcon,
      // SvgIcon sets `fill: currentColor`, which would beat the `fill="none"`
      // attribute and flood the outline glyph.
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    <path d="M22 2L11 13" />
    <path d="M22 2l-7 20-4-9-9-4z" />
  </SvgIcon>
);

/**
 * Pager chevrons traced from the Teams design. `@mui/icons-material` ships
 * filled glyphs; the design uses a thin stroked chevron, so these are drawn
 * here with the stroke weight and size coming from the screen tokens.
 */
const PagerChevron: React.FC<SvgIconProps> = ({ children, sx, ...rest }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={size.pageArrowStrokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{
      width: size.pageArrow,
      height: size.pageArrow,
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

export const PagerPrevIcon: React.FC<SvgIconProps> = (props) => (
  <PagerChevron {...props}>
    <path d="M15 18l-6-6 6-6" />
  </PagerChevron>
);

export const PagerNextIcon: React.FC<SvgIconProps> = (props) => (
  <PagerChevron {...props}>
    <path d="M9 6l6 6-6 6" />
  </PagerChevron>
);
